/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";

const RightPanel = (props) => {

	const closePanel = () => {
		if(props?.onClose){
			props.closePanel();
			setTimeout(() => {
				props?.onClose(props?.title);
			}, 500);
		}else{
			props.closePanel()
		}
	}

	return (
		<div
			id="languages-panel"
			className={`right-panel-wrapper is-languages ${
				props?.open ? "is-active" : ""
			}`}
		>
			<div className="panel-overlay" onClick={() => {
							props.open ? closePanel() : props.openPanel();
						}} />
			<div className={`right-panel ${props?.customClassName}`} style={props?.customStyle||{}}>
				<div className="right-panel-head">
					<h3>{props?.title}</h3>
					<a
						className="close-panel"
						onClick={() => {
							props.open ? closePanel() : props.openPanel();
						}}
					>
						<i data-feather="chevron-right" />
					</a>
				</div>
				<div className="right-panel-body has-slimscroll">
					{props.content ? props.content : props?.content2 ? props?.content2 : undefined }
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return { ...state.rightPanel };
};

const mapDispatchToProps = (dispatch) => {
	return {
		openPanel: () => dispatch(openPanel()),
		closePanel: () => dispatch(closePanel()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RightPanel);
